import { Injectable } from "@angular/core";
import { AppService } from "../../../../../core/service/Base.Service";
@Injectable()
export class joinmeetingService extends AppService<any> {
  constructor() {
    super("joinmeeting");
  }

  async meetingRequests(typeid, referenceid, fromtypeid) {
    let entityid = this.localStorage.get("selectedEntity");
    const result = await this.get("joinMeeting", [
      Number(entityid),
      typeid,
      referenceid,
      fromtypeid,
    ]);
    return result;
  }

  async startmeeting(scheduleid, employeeid) {
    const result = await this.get("StartMeeting", [scheduleid, employeeid]);
    return result;
  }

  async updateMeetingStatus(meetingid, statusid) {
    const result = await this.get("updateMeetingStatus", [meetingid, statusid]);
    return result;
  }

  async getParticipantInfo(meetingid, participantid) {
    const result = await this.get("ParticipantInfo", [
      meetingid,
      participantid,
    ]);
    return result;
  }

  async getActiveParticipants(meetingid) {
    const result = await this.get("ActiveParticipants", [meetingid]);
    return result;
  }

  async setParticpantStatus(particpantid, meetingid, statusid, guesttypeid) {
    const result = await this.get("ParticpantStatus", [
      particpantid,
      meetingid,
      statusid,
      guesttypeid,
    ]);
    return result;
  }

  async getjoinMeeting(
    typeid,
    referenceid,
    fromtypeid,
    courseid,
    sectionid,
    subjectid,
    topicdtlid
  ) {
    let entityid = Number(this.localStorage.get("selectedEntity"));
    const result = await this.get("joinMeeting", [
      entityid,
      typeid,
      referenceid,
      fromtypeid,
      courseid,
      sectionid,
      subjectid,
      topicdtlid,
    ]);
    return result;
  }

  async parentmeetingRequests(typeid, referenceid, fromtypeid) {
    let entityid = this.localStorage.get("selectedEntity");

    const result = await this.get("joinMeeting", [
      Number(entityid),
      typeid,
      referenceid,
      fromtypeid,
    ]);
    return result;
  }

  async gethostingURL() {
    let entityid = this.localStorage.get("selectedEntity");

    const result = await this.get("hostingURL", [Number(entityid)]);
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/shell/forms/Communication/joinmeeting/joinmeeting/joinmeeting.service.ts